import { useState } from "react";

export default function useFormErrors(initialErrors = {}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [errors, setErrors] = useState(initialErrors);

  const setError = (name, message) => {
    setErrors((prev) => ({ ...prev, [name]: { message } }));
  };

  const clearError = (name) => {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  };

  const validateField = (
    name,
    value,
    pattern,
    isRequired,
    requiredMessage,
    invalidMessage
  ) => {  
    if (isRequired) {
      if (value === "") {
        setError(name, requiredMessage);
        return true;
      } else if (pattern && !RegExp(pattern).test(value)) {
        setError(name, invalidMessage);
        return true;
      } else {
        clearError(name);
        return false;
      }
    } else {
      if(value !== "") { 
        if (pattern && !RegExp(pattern).test(value)) {
          setError(name, invalidMessage);
          return true;
        } else {
          clearError(name);
          return false;
        }
      }
    }
  };

  const validateFields = (fields) => {
    let isError = false;
    for (const field of fields) {
      const result = validateField(
        field.name,
        field.value,
        field.pattern,
        field.isRequired,
        field.requiredMsg,
        field.invalidMsg
      );
      if (result) isError = true;
    }
    return isError;
  };

  const hasErrors = () => Object.keys(errors).length > 0;

  return {
    errors,
    setError,
    clearError,
    validateField,
    validateFields,
    hasErrors,
    setErrors,
  };
}
